import { ITemplate } from './i-template';
import { Section } from './section';

export class Template implements ITemplate {
  /** 模板選取器 */
  selector: string;
  /** 模板主題 */
  themeClass: string;
  /** 模板區塊 */
  sections: Array<Section>;
  /** 是否顯示胖胖頁腳 */
  showFooter = true;
  /** 模板頁面呈現的自定義資料 */
  data?: any;
}
